import { DataReduceBase } from '@mjcloud/reduce';

export abstract class FormReduceBase extends DataReduceBase {}
